const initialState = {
    isDeletingTag: false,
    isUpdatingTag: false,
}

export default initialState;
